import { useQuery, useMutation } from "@tanstack/react-query";
import {
  changeFinancialyear,
  fetchAllFinancialyears,
} from "services/financialyear";

export const useAllFinancialyears = (filters = {}) => {
  const query = useQuery({
    queryKey: ["all-financialyears", filters],
    queryFn: () => fetchAllFinancialyears(filters),
  });
  return query;
};

export const useChangeFinancialyear = () => {
  return useMutation({
    mutationKey: ["change-financialyear"],
    mutationFn: (id) => changeFinancialyear(id),
  });
};

